import { render, staticRenderFns } from "./SalaCalendarioNuevoDia.vue?vue&type=template&id=3f529ff3&scoped=true"
import script from "./SalaCalendarioNuevoDia.vue?vue&type=script&lang=js"
export * from "./SalaCalendarioNuevoDia.vue?vue&type=script&lang=js"
import style0 from "./SalaCalendarioNuevoDia.vue?vue&type=style&index=0&id=3f529ff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f529ff3",
  null
  
)

export default component.exports